import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ModelVariantUnitsList from './ModelVariantUnitsList';
import { getModelVariantUnits, getUserProfileWidget } from '../../selectors/index';
import {
  getModelVariantUnitsThunk,
  setModelVariantUnitsFilteredDataThunk,
  resetModelVariantUnitsThunk,
  setModelVariantUnitsCurrentPage,
  uploadConfigToS3AndUpdateShadowThunk
} from '../../actions/modelVariant';

const mapStateToProps = state => {
  return {
    modelVariantUnitManager: getModelVariantUnits(state),
    userProfileWidgets: getUserProfileWidget(state),
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setCurrentPage: currentPage => setModelVariantUnitsCurrentPage(currentPage),
      getModelVariantUnits: item => getModelVariantUnitsThunk(item, 'MODELVARIANT_UNIT_VIEW'),
      setFilterData: filteredData => setModelVariantUnitsFilteredDataThunk(filteredData),
      resetModelVariantUnits: modelVariantUnits => resetModelVariantUnitsThunk(modelVariantUnits),
      uploadConfigToS3AndUpdateShadow: (modelCategoryId, modelId, modelVariantId) =>
          uploadConfigToS3AndUpdateShadowThunk(modelCategoryId, modelId, modelVariantId,'MODELVARIANTUNITSHADOWUPDATE')

    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelVariantUnitsList);
